import { graphql } from '@/gql'

export const CreateJobCandidateMutation = graphql(/* GraphQL */ `
  mutation createJobCandidateMutation($input: CreateJobCandidateInput!) {
    createJobCandidate(input: $input) {
      id
    }
  }
`)

export const UpdateJobCandidatePreferredMutation = graphql(/* GraphQL */ `
  mutation updateJobCandidatePreferred($input: UpdateJobCandidatePreferredInput!) {
    updateJobCandidatePreferred(input: $input) {
      id
      isPreferred
    }
  }
`)

export const UpdateJobCandidateStatusMutation = graphql(/* GraphQL */ `
  mutation updateJobCandidateStatus($input: UpdateJobCandidateStatusInput!) {
    updateJobCandidateStatus(input: $input) {
      id
    }
  }
`)
